import {z} from 'zod';
import definition from '../config/email-sign-in.json' with {type: 'json'};
import {EmailSchema} from './auth-policy.js';

export const emailSignInPolicy = z.object({
  codeDigits: z.number().int().min(6).max(12), lifetimeSeconds: z.number().int().min(60).max(1800),
  resendAfterSeconds: z.number().int().min(30).max(300), maximumAttempts: z.number().int().min(1).max(10),
  rateWindowSeconds: z.number().int().positive(), maximumEmailSends: z.number().int().positive(),
  maximumPeerSends: z.number().int().positive(), maximumPeerVerifications: z.number().int().positive()
}).strict().parse(definition);
export const EmailCodeStartSchema = z.object({email: EmailSchema}).strict();
export const EmailCodeFinishSchema = z.object({challengeToken: z.string().regex(/^[0-9a-f]{64}$/),
  code: z.string().length(emailSignInPolicy.codeDigits).regex(/^[0-9]+$/)}).strict();
export interface EmailCodeChallenge {challengeToken: string; email: string; expiresAt: string; retryAfterSeconds: number}
